import { render, staticRenderFns } from "./FormRegistration.vue?vue&type=template&id=71fcc117&scoped=true&"
import script from "./FormRegistration.vue?vue&type=script&lang=js&"
export * from "./FormRegistration.vue?vue&type=script&lang=js&"
import style0 from "./FormRegistration.vue?vue&type=style&index=0&id=71fcc117&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fcc117",
  null
  
)

export default component.exports